/**
 * 新建 or 编辑问题
 */
import { useState, useEffect, useRef, forwardRef, useImperativeHandle, RefObject } from 'react'
import {
  Form,
  Select,
  Row,
  Col,
  message,
  Input,
  DatePicker,
  Spin,
  ConfigProvider,
  TreeSelect,
  Drawer,
  Button,
  Upload,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { filterSerchData, momentFormData, propsDragger } from '@/utils/common'
import zhCN from 'antd/locale/zh_CN'
import { SearchListModal } from './searchList'
import { isObject,isArray } from 'lodash-es'
import { CloseCircleOutlined } from '@ant-design/icons'
import { SCommonDialog, SDrawer } from 'shj-components'
import dayjs from 'dayjs'
import { getIssueDetail, addIssueOrUpdate, getEnums } from '@/services/homeService'
import { useSetState } from 'ahooks'

const { Option } = Select
const { TextArea } = Input

export const CheckThePhoneInp = (props: any) => {
  const { fn, id, encodeValue, sysItem, param1, type } = props
  const [_fullPhone, _setFullBackPhone] = useState('')
  return (
    <div
      onClick={() => {
        if (_fullPhone == '') {
          // sysItem: "WORKER_ORDER"   "ISSUE"
          // param1: 签约电话，联系电话
          if (type && type === 'clue') {
            viewPhone({ params: { id } }).then((res: any) => {
              _setFullBackPhone(res)
              fn && fn(res);
            });
          } else {
            operatePhoneLog(id, 'SEE_PHONE_NUMBER', sysItem, param1).then((resp: any) => {
              if (resp.data.message != 'success') {
                message.error('获取失败')
                return
              }
              getDecodeValue(encodeValue).then((res: any) => {
                if (res?.data) {
                  _setFullBackPhone(res?.data)
                  fn && fn(res?.data)
                }
              })
            })
          }
        } else {
          _setFullBackPhone('')
          fn && fn('')
        }
      }}
    >
      {_fullPhone ? (
        <Button icon={<EyeOutlined />} type="text" size="small" />
      ) : (
        <Button icon={<EyeInvisibleOutlined />} type="text" size="small" />
      )}
    </div>
  )
}
export default function arrToListOption(arr:any[] = [], { value = 'text', title = 'title' } = {}) {
  if (!isArray(arr)) return null;
  return arr.map((item, index) => (
    <Select.Option key={index + value} value={item[value]} data={item}>
      {item[title]}
    </Select.Option>
  ))
}

export const ModalAddMatterTab = (props: any) => <ModalAddMatterDom {...props} />

export function modalAddMatterFn(val: any) {
  const onClose = () => {
    dialog.destroy()
  }

  const dialog = SCommonDialog({
    title: val?.isEdited ? `编辑问题` : `新建问题`,
    width: '80%',
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <ModalAddMatterDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  })
  return dialog
}

const ModalAddMatterDom = forwardRef((params: any, ref: any) => {
  const {
    onClose,
    onOk,
    issueId,
    isEdited,
    channelConfig,
    internalConfig,
    exposureConfig,
    companyList,
    orderIssueLevelEnum,
    loading,
    setLoading,
    open
  } = params
  const formNode = useRef<any>()
  const [form] = Form.useForm()

  const [spinLoading, setSpinLoading] = useState(false)
  const [fileList, setFileList] = useState([]) // 文件存放地址
  const [classifyId, setClassifyId] = useState<string>()
  const [customerInfo, setCustomerInfo]: any = useState({})
 
  const [detailData, setDetailData]: any = useState({})

  const [state, setState] = useSetState({
    searchListOpen: false,
    channelConfig: [],
    exposureConfig: [],
    issueTypeEnum: [],
    companyList: [],
    orderIssueLevelEnum: [],
    channelTree: [],
  })

  const onChange = (newValue: string) => {
    setClassifyId(newValue)
  }

  useEffect(() => {
    if (open) {
      form.resetFields()
      setFileList([])
      initFn()
    }
  }, [issueId, open])
  const initFn = async () => {
    setSpinLoading(true)
    if (isEdited) {
      const data = await getIssueDetail(issueId)      
      data?.typeId ? (data['typeId'] = data?.typeId?.toString()) : delete data.typeId
      data?.levelId ? (data['levelId'] = data?.levelId?.toString()) : delete data.levelId
      data?.classifyId ? (data['classifyId'] = data?.classifyId.split(',')) : delete data.classifyId

      let ourFiles = data?.files && JSON.parse(data['files'])
      ourFiles =
        data?.files &&
        ourFiles.map((val: any, index: any) => {
          return {
            uid: index,
            name: val.name,
            status: 'done',
            url: val.path,
            path: val.path,
            type: val.type,
          }
        })
      setFileList(ourFiles || [])

      let _customerInfo = data.customerInfo
      _customerInfo = momentFormData(_customerInfo, [
        'handoverDate',
        'planStartDate',
        'planEndDate',
        'actualStartDate',
        'actualEndDate',
        'disclosureDate',
      ])
     
      form.setFieldsValue({
        ...data,
        ..._customerInfo,
        ...{ name: _customerInfo['name'] },
        ...{ file: ourFiles || [] },
      })
      const detailData = { ...data }
      setDetailData(detailData)
      setCustomerInfo(_customerInfo)
      setSpinLoading(false)
    }

    getEnums('crm', 'com.shj.saas.crm.domain.tickets.enums.OrderIssueTypeEnum').then(
      issueTypeEnum => {
        setState({ issueTypeEnum })
      }
    )
    setSpinLoading(false)
  }

  const btnStatus = (otherStatus: boolean) => {
    return otherStatus
  }

  const onFinish = (values: any) => {
    if (loading) return
    setLoading(true)
    let ourParams = {
      ...values,
      ...filterSerchData({ ...values }, [
        'handoverDate',
        'planStartDate',
        'planEndDate',
        'actualStartDate',
        'actualEndDate',
        'disclosureDate',
      ]),
    }
    Object.keys(ourParams).map(v => {
      if (isObject(ourParams[v])) {
        ourParams[v] = ourParams[v].toString()
      }
    })

    ourParams = {
      ...ourParams,
      ...{
        customerInfo: {
          ...customerInfo,
          ...ourParams,
          ...{ bizOpId: customerInfo?.id },
          ...{ phoneEncode: customerInfo?.phoneEncode || detailData?.phoneEncode },
        },
      },
      ...{ id: isEdited ? issueId : '' },
      ...{ feedbackPhoneEncode: detailData?.feedbackPhoneEncode || '' },
      ...{ file: fileList },
    }
    setLoading(true)

    addIssueOrUpdate(ourParams)
      .then((resp: any) => {
        message.success(`${resp?.data?.message}`)
        // fn && fn()
        setLoading(false)
        onOk?.()
        onClose()
      })
      .catch((err: any) => {
        setLoading(false)
        console.error('err', err)
      })
  }

  const handleSubmit = () => {
    form.validateFields().then(onFinish)
  }
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList
  }

  useImperativeHandle(
    ref,
    () => ({
      reset: () => form.resetFields(),
      submit: () => handleSubmit(),
    }),
    [onFinish, detailData]
  )

  const handleSearchListOk = val => {
    let _customerInfo = {
      id: val?.id,
      "createdTime": val.createdTime,
      "lastUpdatedTime": val.lastUpdatedTime,
      "createdBy": val.createdBy,
      "modifiedBy": val.modifiedBy,
      "tenantId": val.tenantId,
      // "bizOpId": "",
      // "issueId": "",
      "name": val?.bizCustomVo?.name,
      "phone": val?.bizCustomVo?.phone,
      "phoneEncode": "",
      "stateDisplay": val.stateName,
      "companyCode": val?.companyCode,
      "companyName": val?.companyName,
      "buildingName": val?.bizBuildVo?.name || "",
      "houseNumber": val?.houseInfoVo?.houseNumber ?? "",

      "typeDisplay": val.typeName,
      "designDeptDisplay": val?.designRel?.deptName,
      "designerDisplay": val?.designRel?.relativePerson,
      "designerManager": val?.designMngRel?.relativePerson,
      "deliveryDept": val?.bizDtlDoneVo?.deliveryDeptName,
      "deliveryManager": "",

      "projectCode": "",
      "projectState": "",
      "projectManager": val?.bizDtlDoneVo?.projectManager,
      "engineeringSupervision": val?.bizDtlDoneVo?.engineeringSupervision,
      "softSteward": "",
      "handoverDate": val?.bizBuildVo?.handoverDate,
      "planStartDate": val?.bizDtlConstructVo?.planStartDate,
      "planEndDate": val?.bizDtlConstructVo?.planEndDate,
      "actualStartDate": val?.bizDtlConstructVo?.actualStartDate,
      "actualEndDate": val?.bizDtlConstructVo?.actualEndDate,
      "disclosureDate": val?.bizDtlConstructVo?.disclosureDate,
      // "remoteSite": true,
      // "visual": true
    }
    // let _customerInfo = {
    //   ...val,
    //   ...val.completionPeriodInfo,
    //   ...val.underConstructionPeriodInfo,
    // }
    _customerInfo = momentFormData(_customerInfo, [
      'handoverDate',
      'planStartDate',
      'planEndDate',
      'actualStartDate',
      'actualEndDate',
      'disclosureDate',
    ])
    form.setFieldsValue({
      ..._customerInfo,
      ...{
        name: _customerInfo.name,
        companyId: _customerInfo.companyCode, //所属分公司
        feedPhone: _customerInfo.phone, //签约电话
      },
    })
    setCustomerInfo(_customerInfo)
  }

  const handleSearchListShow = () => {
    setState({ searchListOpen: true })
  }

  const {
    issueTypeEnum,
  } = state
  return (
    <div>
      <Spin spinning={spinLoading} tip="加载中...">
        <Form
          ref={formNode}
          form={form}
          onFinish={onFinish}
          {...{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 18 },
            },
          }}
        >
          <Row gutter={2}>
            <Col span={8}>
              <Form.Item
                label="来源"
                name="channelId"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <TreeSelect
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="请选择"
                  treeDefaultExpandAll
                  onChange={(newValue, _, node) => {
                    form.setFieldsValue({ levelId: node?.triggerNode?.props?.levelId?.toString() })
                    formNode?.current?.setFieldsValue({ channelId: newValue })
                  }}
                  treeData={channelConfig}
                  showSearch={true}
                  allowClear
                  filterTreeNode={(inputValue: any, treeNode: any) => {
                    console.log('treeNode-----------',treeNode)
                    return treeNode.title?.toLowerCase()?.indexOf(inputValue.toLowerCase()) >= 0
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="类型"
                name="typeId"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select
                  disabled={btnStatus(false)}
                  placeholder="请选择"
                  allowClear
                  showSearch
                  filterOption={(input, option) => option?.props?.children?.indexOf?.(input) >= 0}
                >
                  {arrToListOption(issueTypeEnum, { value: 'key', title: 'description' })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="提起曝光渠道" name="exposureId">
                <TreeSelect
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="请选择"
                  treeDefaultExpandAll
                  onChange={newValue => {
                    formNode?.current?.setFieldsValue({ exposureId: newValue })
                  }}
                  treeData={exposureConfig}
                  showSearch={true}
                  allowClear
                  filterTreeNode={(inputValue: any, treeNode: any) => {
                    return treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="分类"
                name="classifyId"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <TreeSelect
                  showSearch={true}
                  value={classifyId}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="请选择"
                  allowClear
                  multiple
                  // treeDefaultExpandAll
                  onChange={onChange}
                  treeData={internalConfig}
                  filterTreeNode={(inputValue: any, treeNode: any) => {
                    return treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="客户名称" name="name" required rules={[{ required: true }]}>
                <Input
                  placeholder="请输入"
                  style={{ width: '100%' }}
                  onChange={() => {
                    setCustomerInfo({})
                  }}
                  addonAfter={
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div
                        style={{
                          width: '80%',
                          height: '100%',
                          cursor: 'pointer',
                          borderRight: 'px solid #eee',
                          textAlign: 'center',
                        }}
                        onClick={() => {
                          handleSearchListShow()
                        }}
                      >
                        选择客户
                      </div>
                      <div style={{ width: '10%', cursor: 'pointer', textAlign: 'center' }}>
                        <CloseCircleOutlined
                          onClick={() => {
                            form.setFieldsValue({
                              name: '',
                              companyId: '',
                              phone: '',
                              stateDisplay: '',
                              buildingName: '',
                              houseNumber: '',
                              projectCode: '',
                              typeDisplay: '',
                              designDeptDisplay: '',
                              designerDisplay: '',
                              designerManager: '',
                              deliveryDept: '',
                              deliveryManager: '',
                              projectManager: '',
                              engineeringSupervision: '',
                              softSteward: '',
                              feedPhone: '',
                              handoverDate: '',
                              planStartDate: '',
                              planEndDate: '',
                              actualStartDate: '',
                              actualEndDate: '',
                              disclosureDate: '',
                            })
                            setCustomerInfo({})
                          }}
                        />
                      </div>
                    </div>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="所属分公司"
                name="companyId"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  {arrToListOption(companyList, { value: 'code', title: 'name' })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="联系电话"
                name="feedbackPhone"
                required
                rules={[{ required: true, message: '请输入联系电话' }]}
              >
                <Input
                  type="tel"
                  disabled={btnStatus(false)}
                  placeholder="请输入联系电话"
                  style={{ width: '100%' }}
                  addonAfter={
                    isEdited ? (
                      <CheckThePhoneInp
                        id={issueId}
                        sysItem={'ISSUE'}
                        param1={'联系电话'}
                        fn={(val: any) => {
                          if (val == '') {
                            form.setFieldsValue({ feedbackPhone: detailData?.feedbackPhone })
                          } else {
                            form.setFieldsValue({ feedbackPhone: val })
                          }
                        }}
                        encodeValue={detailData?.feedbackPhoneEncode}
                      ></CheckThePhoneInp>
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="签约电话"
                name="phone"
                required
                rules={[{ required: true, message: '请输入签约电话' }]}
              >
                <Input
                  type="tel"
                  disabled={btnStatus(false)}
                  placeholder="请输入签约电话"
                  style={{ width: '100%' }}
                  addonAfter={
                    isEdited ? (
                      <CheckThePhoneInp
                        id={issueId}
                        sysItem={'ISSUE'}
                        param1={'签约电话'}
                        fn={(val: any) => {
                          if (val == '') {
                            form.setFieldsValue({ phone: customerInfo?.phone })
                          } else {
                            form.setFieldsValue({ phone: val })
                          }
                        }}
                        encodeValue={customerInfo?.phoneEncode}
                      ></CheckThePhoneInp>
                    ) : null
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="状态"
                name="stateDisplay"
                required
                rules={[{ required: true, message: '请输入状态' }]}
              >
                <Input
                  disabled={btnStatus(false)}
                  placeholder="请输入状态"
                  style={{ width: '100%' }}
                />
                {/* <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  <Option value="1">待受理</Option>
                  <Option value="2">处理中</Option>
                  <Option value="4">已处理</Option>
                  <Option value="3">已归档</Option>
                  <Option value="9">不成立</Option>
                </Select> */}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="楼盘名称" name="buildingName">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="房号" name="houseNumber">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="项目编号" name="projectCode">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="需求类型" name="typeDisplay">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="设计部门" name="designDeptDisplay">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="设计师" name="designerDisplay">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="设计部经理" name="designerManager">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="交付部门" name="deliveryDept">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="交付经理" name="deliveryManager">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="项目经理" name="projectManager">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="质检员" name="engineeringSupervision">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="软装管家" name="softSteward">
                <Input disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="交付日期" name="handoverDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="计划开工日期" name="planStartDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="计划完工日期" name="planEndDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="实际开工日期" name="actualStartDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="实际竣工日期" name="actualEndDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="交底日期" name="disclosureDate">
                <DatePicker
                  disabled={btnStatus(false)}
                  style={{ width: '100%' }}
                  allowClear
                  showTime={{
                    defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="是否远程工地" name="remoteSite">
                <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  <Option value={true}>是</Option>
                  <Option value={false}>否</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="是否可视化工地" name="visual">
                <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  <Option value={true}>是</Option>
                  <Option value={false}>否</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="问题级别"
                name="levelId"
                required
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  {arrToListOption(orderIssueLevelEnum, { value: 'key', title: 'description' })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="问题描述"
                name="description"
                required
                rules={[{ required: true, message: '请输入' }]}
                labelCol={{
                  xs: { span: 4 },
                  sm: { span: 2 },
                }}
                wrapperCol={{
                  xs: { span: 20 },
                  sm: { span: 22 },
                }}
              >
                <TextArea
                  disabled={btnStatus(false)}
                  placeholder="请输入"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                extra="支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif"
                label="上传附件"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                name="file"
                style={{ marginBottom: 0 }}
                labelCol={{
                  xs: { span: 4 },
                  sm: { span: 2 },
                }}
                wrapperCol={{
                  xs: { span: 20 },
                  sm: { span: 22 },
                }}
              >
                <Upload
                  {...propsDragger({
                    fileList,
                    fn: (val: any) => {
                      setFileList(val)
                    },
                  })}
                  listType="picture-card"
                >
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>选择图片</div>
                  </div>
                </Upload>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Spin>
      <SearchListModal
        open={state.searchListOpen}
        onClose={() => setState({ searchListOpen: false })}
        onOk={handleSearchListOk}
      />
    </div>
  )
})

export const AddMatterModal = (props: any) => {
  const { open, onClose, isEdited } = props
  const ref: RefObject<any> = useRef()
  const [loading, setLoading] = useState(false)
  const handleReset = () => ref.current?.reset?.()
  const handleOk = () => ref.current?.submit?.()

  return (
    <SDrawer
      title={isEdited ? `编辑问题` : `新建问题`}
      open={open}
      resetText="取消"
      onClose={onClose}
      width="86%"
      onResetFn={onClose}
      onSubmit={handleOk}
      loading={loading}
    >
      <ModalAddMatterDom ref={ref} loading={loading} setLoading={setLoading} open={open} {...props} />
    </SDrawer>
  )
}